angular.module('app')
.config(function($stateProvider) {
  $stateProvider
    .state('admin2',{
      url: '/admin2',
      templateUrl: '../views/admin2.html',
      controller: 'adminController',
      onEnter: function($state, auth){
        if(!auth.isLoggedIn()){
          $state.go('admin');
        }
      }
    });
})
.controller('adminController', function($scope, storageFactory, picsFactory, FileUploader){
  $scope.volunteers = [];
  $scope.emails = [];
  $scope.pics = [];

  storageFactory.allVolunteers(function(data){
    $scope.volunteers = data;
    // console.log($scope.volunteers);
  });

  storageFactory.allEmails(function(data){
    $scope.emails = data;
    // console.log($scope.emails);
  });

  picsFactory.getPics(function(data){
    $scope.pics = data;
    // console.log($scope.pics);
  });

  $scope.delete = function(){
    $scope.garbage = [];
    for(var x in $scope.pics.Contents){
      if($scope.pics.Contents[x].selected === true){
        $scope.garbage.push($scope.pics.Contents[x].Key);
      }
    }
    picsFactory.deletePics($scope.garbage, function(res){
      for(var x in $scope.pics.Contents){
        for(var y in res.Deleted){
          if($scope.pics.Contents[x].Key === res.Deleted[y].Key){
            $scope.pics.Contents.splice($scope.pics.Contents.indexOf($scope.pics.Contents[x]), 1);
          }
        }
      }
    });
  };

  // --------------------------File Upload---------------------------

  var uploader = $scope.uploader = new FileUploader({
            url: '/newPic',
            removeAfterUpload: true,
        });

        // CALLBACKS
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
          item.formData = [{data: 'data'}];
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            $scope.pics.Contents.push({Key:fileItem.file.name});
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
        };
        // console.info('uploader', uploader);
});
